import { Table } from 'antd'
import { createContext, FC } from 'react'
import { useGetRewindQueueEntriesQuery } from '../../../../store/api/rewind-queue-entries-api'
import Machine from '../../../../types/api/machine'
import RewindQueueEntry from '../../../../types/api/rewind-queue-entry'
import RewindQueueTableWrapper from '../../../schedules/rewind/components/rewind-queue-table-wrapper'
import { getRewindRowClassName } from '../../../schedules/rewind/helpers/get-rewind-row-class-name'
import { columns } from './columns'
import { getQueryParams } from './helpers/get-query-params'

export const OneRewinderMachineScheduleContext = createContext<RewindQueueEntry[]>([])

interface OneRewinderMachineScheduleProps {
    machine: Machine
}

const OneRewinderMachineSchedule: FC<OneRewinderMachineScheduleProps> = ({ machine }) => {
    const queryParams = getQueryParams(machine)
    const { data } = useGetRewindQueueEntriesQuery(queryParams, {
        pollingInterval: 5000,
        skipPollingIfUnfocused: true,
    })
    const dataSource = data?.data || []

    return (
        <OneRewinderMachineScheduleContext.Provider value={dataSource}>
            <RewindQueueTableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                filtersSummaryHeight={0}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey='documentId'
                    size='small'
                    rowClassName={record => getRewindRowClassName(record.rewind_job)}
                />
            </RewindQueueTableWrapper>
        </OneRewinderMachineScheduleContext.Provider>
    )
}

export default OneRewinderMachineSchedule
